import React from 'react';

import { FormCheck, FormCheckPropsT } from '../FormCheck';

export type RadioButtonPropsT = Omit<FormCheckPropsT, 'type'>;

export type RadioButtonT = React.FC<RadioButtonPropsT>;

export const RadioButton: React.FC<RadioButtonPropsT> = (props) => {
  return <FormCheck {...props} type="radio" />;
};
